const themeServiceName = "/Theme";

export function generalService (http) {
    return {
        getUserTheme: (userProfileId) => {
            const parameter = {
                userProfileId                
            }

            return http.post(themeServiceName + '/GetUserTheme', parameter);
        },
        updateUserTheme: (userProfileId, theme) => {
            const parameter = {
                userProfileId,
                name: theme
            }

            return http.post(themeServiceName + '/UpdateUserTheme', parameter);
        }        
    }
} 